import {useState} from 'react';
import CreateFormSelectMode from './CreateFormSelectMode';
import CreateFormWizard from './CreateFormWizard';
import CreateFormTemplatePreviewList from './CreateFormTemplatePreviewList';

const CreateForm = () => {
    const [stage, setStage] = useState('select');
    const [selectedTemplate, setSelectedTemplate] = useState(null);

    const resetToSelect = () => {
        setStage('select');
        setSelectedTemplate(null);
    };

    const currentTemplateSource = selectedTemplate?.source || 'admicity';

    return (
        <>
            {stage === 'select' && (
                <CreateFormSelectMode
                    onWizard={() => {
                        setSelectedTemplate({mode: 'wizard'});
                        setStage('wizard');
                    }}
                    onBlank={() => {
                        setSelectedTemplate({mode: 'blank'});
                        setStage('wizard');
                    }}
                    onTemplate={() => {
                        setSelectedTemplate({
                            mode: 'template',
                            source: 'admicity',
                        });
                        setStage('wizard');
                    }}
                    onSchoolTemplate={() => {
                        setSelectedTemplate({
                            mode: 'template',
                            source: 'school',
                        });
                        setStage('wizard');
                    }}
                    onEmail={() => {
                        setSelectedTemplate({
                            mode: 'blank',
                            isCommunication: true,
                        });
                        setStage('wizard');
                    }}
                />
            )}

            {stage === 'wizard' && (
                <CreateFormWizard
                    selectedTemplate={selectedTemplate}
                    onBack={(target) => {
                        if (target === 'template') {
                            setStage('preview');
                            return;
                        }
                        resetToSelect();
                    }}
                    onFinish={resetToSelect}
                />
            )}

            {stage === 'preview' && (
                <CreateFormTemplatePreviewList
                    templateSource={currentTemplateSource}
                    onBack={resetToSelect}
                    onTemplateSelected={(template) => {
                        setSelectedTemplate({
                            mode: 'template',
                            source: currentTemplateSource,
                            templateObject: template,
                            templateId: template.id,
                        });
                        setStage('wizard');
                    }}
                />
            )}
        </>
    );
};

export default CreateForm;
